import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import heroImage from "../../assets/hero.avif";
import Login from "../Login/Login";
import { API_BASE_URL } from "../api_config";
import "./register.css";
import RegContent from "./RegContent";
import CardList from "../Cards/Cards";
import UserContext from "../../Components/Authcontext";
import Load from "../Loading/Load";
import { LogIn } from "lucide-react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

import RegisterInfoModal from "./RegisterInfoModal";

const Register = () => {
  const { setUser, setToken } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState("");
  const [looking, setLooking] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [showInfoModal, setShowInfoModal] = useState(true);

  const [isScrolled, setIsScrolled] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleRegister = async (event) => {
    event.preventDefault();
    setLoading(true);
    const response = await axios.post(
      `${API_BASE_URL}/api/register`,
      {
        profile,
        looking,
        mobile,
        password,
        confirm,
      },
      { withCredentials: true }
    );

    if (response.data.auth && mobile !== "" && password !== "") {
      setUser((prevUser) => ({
        ...prevUser,
        userId: response.data.userId,
        userMob: response.data.userMob,
      }));
      setToken(response.data.token);
      Cookies.set("m_host-token", response.data.token, { expires: 7 });
      setLoading(false);
      navigate("/modern-basic-info", { replace: true });
      setProfile("");
      setLooking("");
      setMobile("");
      setPassword("");
      setConfirm("");
    } else if (response.data.error) {
      setLoading(false);
      setError(response.data.error);
    }
  };

  return loading ? (
    <Load />
  ) : (
    <div className="register-new-hero-bg">
      {/* Registration Info Modal */}
      <RegisterInfoModal 
        isOpen={showInfoModal} 
        onClose={() => setShowInfoModal(false)} 
      />
      
      {/* Top Navigation - Sticky */}
      <nav className="register-nav">
        <div className="container">
          <div className="register-nav-row">
            <div className="col-6">
              <div className="register-nav-left">
                <div className="register-nav-group">INDIA'S</div>
                <img src={logo} alt="Matrimony Logo" className="register-nav-logo" />
              </div>
            </div>
            <div className="col-6 text-end">
              <div className="register-nav-right">
                <Link className="register-nav-login"><Login /></Link>
                </div>
            </div>
          </div>
        </div>
      </nav>
      
      {/* Hero Section with Background Images */}
      <div className="register-hero-section">
        {/* Background Image Grid - Only for hero section */}
        <div className="register-bg-image-grid">
          <div className="register-bg-image" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80')" }}></div>
          <div className="register-bg-image" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1529634806980-85c3dd6d34ac?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1169&q=80')" }}></div>
          <div className="register-bg-image" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1511285560929-80b456fea0bc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1169&q=80')" }}></div>
          <div className="register-bg-image" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1537633552985-df8429e8048b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80')" }}></div>
          <div className="register-bg-image" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1591604466107-ec97de577aff?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1171&q=80')" }}></div>
          <div className="register-bg-image" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1609151376730-f246ec0b99e5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80')" }}></div>
        </div>
        
        {/* Hero Section with Main Content */}
        <div className="register-main-content">
          {/* Left Side Content */}
          <div className="register-left-content">
            <h1 className="register-main-heading">Find Your Perfect Match Today</h1>
            <p className="register-sub-heading">Join thousands of happy couples who found their soulmate on our platform. Start your journey to a happy marriage.</p>
            
            {/* Feature Points */}
            <div className="register-features">
              <div className="register-feature-item">
                <div className="register-feature-icon">✓</div>
                <div className="register-feature-text">
                  <div className="register-feature-title">Verified Profiles</div>
                  <div className="register-feature-desc">All profiles are manually verified for authenticity</div>
                </div>
              </div>
              
              <div className="register-feature-item">
                <div className="register-feature-icon">🔒</div>
                <div className="register-feature-text">
                  <div className="register-feature-title">Privacy Control</div>
                  <div className="register-feature-desc">You decide who can view your profile and contact you</div>
                </div>
              </div>
              
              <div className="register-feature-item">
                <div className="register-feature-icon">❤️</div>
                <div className="register-feature-text">
                  <div className="register-feature-title">Perfect Matches</div>
                  <div className="register-feature-desc">Advanced matching algorithm to find compatible partners</div>
                </div>
              </div>
              
              <div className="register-feature-item">
                <div className="register-feature-icon">🎯</div>
                <div className="register-feature-text">
                  <div className="register-feature-title">Success Stories</div>
                  <div className="register-feature-desc">Thousands of successful marriages and counting</div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Registration Card */}
          <div className="register-card-container">
            <div className="register-card">
              <div className="register-card-header">Create a Matrimony Profile</div>
              <form className="register-card-form" onSubmit={handleRegister}>
                
                
                {/* Profile For */}
                <div className="register-select-wrapper">
                  <label className="register-form-label">Matrimony profile for</label>
                  <select className="register-card-input" value={profile} onChange={e => setProfile(e.target.value)} required>
                    <option value="" disabled>Select profile for</option>
                    <option value="Myself">Myself</option>
                    <option value="Daughter">Daughter</option>
                    <option value="Son">Son</option>
                    <option value="Brother">Brother</option>
                    <option value="Sister">Sister</option>
                    <option value="Relative">Relative</option>
                    <option value="Friend">Friend</option>
                  </select>
                </div>
                
                {/* Looking For */}
                <div className="register-select-wrapper">
                  <label className="register-form-label">Looking for</label>
                  <select className="register-card-input" value={looking} onChange={e => setLooking(e.target.value)} required>
                    <option value="" disabled>Select looking for</option>
                    <option value="Bride">Bride(மணமகள்)</option>
                    <option value="Groom">Groom(மணமகன்)</option>
                  </select>
                </div>
                
                {/* Mobile Number */}
                <div className="register-form-group">
                  <label className="register-form-label">Mobile Number</label>
                  <div className="register-card-input-group">
                    <select className="register-card-input register-card-input-country" defaultValue={'+91'}>
                      <option value="+91">+91</option>
                      <option value="+1">+1</option>
                      <option value="+44">+44</option>
                    </select>
                    <input 
                      className="register-card-input register-card-input-tel" 
                      type="tel" 
                      placeholder="Enter mobile number" 
                      value={mobile} 
                      onChange={(e) => {
                        const mobileNum = e.target.value.replace(/\D/g, "");
                        setMobile(mobileNum);
                      }}
                      required 
                    />
                  </div>
                </div>
                
                {/* Password */}
                <div className="register-form-group">
                  <label className="register-form-label">Password</label>
                  <input
                    className="register-card-input"
                    type={showPassword ? "text" : "password"}
                    placeholder="Create password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                  />
                  <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                  </span>
                </div>
                
                {/* Confirm Password */}
                <div className="register-form-group">
                  <label className="register-form-label">Confirm Password</label>
                  <input
                    className="register-card-input"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm password"
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                    required
                  />
                  <span className="password-toggle" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                    {showConfirmPassword ? <MdVisibilityOff /> : <MdVisibility />}
                  </span>
                </div>
                
                {/* Register Button */}
                <button type="submit" className="register-card-btn">
                  <span className="btn-text">REGISTER NOW</span>
                  <span className="btn-icon">→</span>
                </button>
                
                {/* Terms and Error */}
                <div className="register-card-terms">
                  <small>*By clicking register now, I agree to the <Link to="/terms-conditions">T&C</Link> and{" "}
                                <Link to="/privacy-policy">Privacy Policy</Link></small>
                </div>
                {error && <div className="error-message">{error}</div>}
                
                {/* Login Link */}
                <div className="register-login-link">
                  Already have an account? {""} <Link to="">Sign in</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      
      {/* Rest of the page with white background */}
      <div className="register-content-section">
        {/* Trust Badges */}
        <div className="register-trust-badges">
          <div className="register-badge">
            <div className="register-badge-icon">✓</div>
            <div className="register-badge-content">
              <div className="register-badge-title">100%</div>
              <div className="register-badge-text">Mobile-verified profiles</div>
            </div>
          </div>
          <div className="register-badge">
            <div className="register-badge-icon">✓</div>
            <div className="register-badge-content">
              <div className="register-badge-title">4 Crores+</div>
              <div className="register-badge-text">Customers served</div>
            </div>
          </div>
          <div className="register-badge">
            <div className="register-badge-icon">✓</div>
            <div className="register-badge-content">
              <div className="register-badge-title">23 Years</div>
              <div className="register-badge-text">of successful matchmaking</div>
            </div>
          </div>
        </div>
        
        
      </div>
    </div>
  );
};

export default Register;
